<template>
  <div class="marker-action">
    <list-action-form
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="toggle"
    >
      <input type="hidden" name="review-stage" :value="reviewStage" />
      <portal :to="name">
        <div class="marker-action-reviewer">
          <select-field
            :items="stages"
            :value="reviewStage"
            :empty-option="true"
            @selected="onReviewStageSelected"
          >
          </select-field>
          <a
            :class="[
              'btn',
              'btn-lg',
              'btn-secondary',
              { disabled: !reviewStage }
            ]"
            @click.prevent="submit"
          >
            {{ labels.button }}
          </a>
        </div>
      </portal>
    </list-action-form>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { SelectField } from 'vue-bootstrap';

/**
 * The Reviewer component.
 */
export default {
  components: {
    SelectField
  },
  extends: ListAction,
  props: {
    name: {
      type: String,
      required: true,
      validator: value => ['reviewer'].indexOf(value) !== -1
    },
    stages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      reviewStage: null
    };
  },
  methods: {
    toggle() {
      this.$emit('reveal', this.name);
    },
    onReviewStageSelected(name, value) {
      this.reviewStage = value;
    }
  }
};
</script>
